var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCountdown)?_c('v-alert',{attrs:{"type":"warning","outlined":"","text":""}},[_vm._v(" Time Remaining to complete your order for your chosen delivery date "),_c('span',{staticClass:"digit font-weight-bold red--text"},[_vm._v(" "+_vm._s(_vm.formatedTimed)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }